export { useDatadogRum } from './react/context/index.js';
export { withDatadogRum } from './react/hoc/hoc.js';
export { datadogRumTrackFeatureFlagEvaluation } from './core/rum.js';
//# sourceMappingURL=index.js.map
